import React, { FC, useState } from "react";

import classes from "./Vote.module.css";
import SectionHeader from "../Layout/SectionHeader";
import Countdown from "react-countdown";
import { getLang, i18n } from "../../i18n";

interface Props {
  serverTime: number;
  isBlockedDate?: Date;
}

const VoteBlocked: FC<Props> = ({ serverTime, isBlockedDate }) => {
  const lang = getLang();
  const t = i18n.voteBlocked[lang];
  const isBlockedTimestamp = isBlockedDate
    ? new Date(isBlockedDate).getTime() + 1000
    : serverTime;
  const [timeLeft, setTimeLeft] = useState(isBlockedTimestamp - serverTime);
  const tickHandler = (time: number) => {
    setTimeLeft(time);
  };
  return (
    <>
      <SectionHeader label={t.title} back="/votes" black={true} />
      <section className={classes.voting}>
        <div className={classes.fullscreen}>
          <div className="container">
            <div className={classes.blocked}>
              {t.message.split("\n").map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
              <Countdown
                className={classes.timer}
                date={isBlockedTimestamp}
                daysInHours={true}
                onTick={(time) => {
                  tickHandler(time.total);
                }}
                onComplete={() => {
                  setTimeLeft(0);
                  window.location.reload();
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VoteBlocked;
